"use client";

import { Link } from "@/i18n/navigation";
import { useTranslations } from "next-intl";

const CookiePolicy = () => {
  const t = useTranslations("cookiePolicy.sections");

  return (
    <div className="gs--page-column gs--page-column--prose py-16">
      <div className="prose prose-lg mx-auto">
        <h2>{t("intro.title")}</h2>
        <p>{t("intro.text")}</p>

        <h3>{t("necessary.title")}</h3>
        <p>{t("necessary.text")}</p>

        <h3>{t("analytics.title")}</h3>
        <p>{t("analytics.text")}</p>

        <h3>{t("moreInfo.title")}</h3>
        <p>
          {t.rich("moreInfo.text", {
            link: (chunks) => (
              <Link href="/datenschutz" className="text-primary underline">
                {chunks}
              </Link>
            ),
          })}
        </p>
      </div>
    </div>
  );
};

export default CookiePolicy;
